/**
 * @incternal
 */
export var SubEntityType = {
    Accessories: 'accessories',
    Attributes: 'attributes',
    Bullets: 'bullets',
    Features: 'features',
    Groups: 'groups',
    Images: 'images',
    KeySellingPoints: 'keysellingpoints',
    Products: 'products',
    Related: 'related',
};
